import Commerce from "@chec/commerce.js";

// a new instance of the commerce (store) is created. & give the public key of the store (chec account)
export const commerce = new Commerce(
  "pk_test_22725e96dcf157b89e48ebe2d29a011ed54c1d8bbe187",
  true
);
